import { useQuery } from '@apollo/client'
import { ColumnProps } from 'antd/lib/table'
import { FormikErrors } from 'formik'
import * as React from 'react'

import { FormValues } from '../form'
import { TalkApolloClient } from '../talk-apollo-client'
import { GetConversations } from './TalkListApollo.queries'
import { TalkList, TalkListBasicProps, TalkListProps } from './TalkList'

export type TalkListApolloProps = TalkListBasicProps & {
    client: TalkApolloClient
    parentId: string
    userId: string
    pollInterval?: number
}

export const TalkListApollo: React.FC<TalkListApolloProps> = (props) => {
    const talkListContainerHookProps: TalkListContainerHookProps = {
        client: props.client,
        columns: props.columns,
        onConversationClick: props.onConversationClick,
        parentId: props.parentId,
        permissions: props.permissions,
        submit: props.submitCreateNewDiscussion,
        userId: props.userId,
        pollInterval: props.pollInterval
    }
    return <TalkListContainerHook {...talkListContainerHookProps} />
}

interface TalkListContainerHookProps {
    client: TalkApolloClient
    columns: ColumnProps<{}>[]
    onConversationClick: (record: {}) => void
    onNewConversationClick?: () => void
    parentId: string
    permissions: { canCreateNewConversation: boolean }
    pollInterval?: number
    submit: (values: FormValues) => Promise<FormikErrors<FormValues>>
    userId: string
}

const TalkListContainerHook: React.FC<TalkListContainerHookProps> = (props) => {
    const pollInterval =
        props.pollInterval !== undefined ? props.pollInterval : 5000
    const { data, error, loading: conversationLoading } = useQuery(
        GetConversations,
        {
            client: props.client,
            variables: { parent: props.parentId },
            pollInterval
        }
    )

    if (error)
        return (
            <div style={{ overflow: 'auto', maxHeight: '500px' }}>
                <h1>Error in TalkListApollo</h1>
                <ul>
                    <li>extraInfo: {error.extraInfo}</li>
                    <li>
                        <pre>
                            graphQLErrors:
                            {error.graphQLErrors.map(({ message }, i) => (
                                <span key={i}>{message}</span>
                            ))}
                        </pre>
                    </li>
                    <li>message: {error.message}</li>
                    <li>name: {error.name}</li>
                    <ul>
                        networkError:
                        <li>name: {error.networkError?.name}</li>
                        <li>message: {error.networkError?.message}</li>
                        <li>stack: {error.networkError?.stack}</li>
                    </ul>
                    <li>stack: {error.stack}</li>
                </ul>
                <h2>Props:</h2>
                {JSON.stringify(props, null, '\t')}
            </div>
        )

    if (conversationLoading) return <div>Conversation list loading...</div>

    const talkListProps: TalkListProps = {
        columns: props.columns,
        conversations: data.conversations,
        onConversationClick: props.onConversationClick,
        submitCreateNewDiscussion: props.submit,
        permissions: props.permissions
    }

    return <TalkList {...talkListProps} />
}
